// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginForm_root___lcZc","input-box":"LoginForm_input-box__pTDxq","input-box--checkbox":"LoginForm_input-box--checkbox__nz9wH"};